import { Navigate, Outlet, useLocation } from "react-router-dom";

import useAuth from "../hooks/useAuth";
import FullscreenLoading from "./shared/LoadingWheelFullscreen";

export default function RequireAuth() {
  const { user, loading } = useAuth();
  const location = useLocation();

  return !loading ? (
    user ? (
      <Outlet />
    ) : (
      <Navigate to="/login" state={{ from: location }} replace />
    )
  ) : (
    <FullscreenLoading />
  );
}
